import React = require('react');
import { IPolicyApplication, IPremium } from '../../../../../data/api/models';
import { capitalize, filter, flow, get, head, last } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { IconCircle } from '../../../../../components/Icons/IconCircle';
import { StatusBadge } from '../PolicyCard/Components/StatusBadge';
import { REGION_MAPPING } from '../../../../../services/quote/models';
import AdmIcons from '../../../../../components/Icons/AdmIcons';
import RepurchaseQuote from './Components/RepurchaseQuote';
import QuoteDetailsView from './Components/QuoteDetailsView';
import { differenceInDays, isAfter, parse } from 'date-fns';

interface IQuoteCard {
  quote: IPolicyApplication
  actions: {
    push: (route: string) => void;
  }
}

const QuoteCard = ({ quote }: IQuoteCard) => {

  const isAnnual = quote.tripType === 'annual';
  const tripDefinition = isAnnual ? 'Annual Multi Trip - ' + get(REGION_MAPPING, quote.region) : 'Single Trip - ' + get(quote, 'destinations', []).toString();
  const status = quote.status;
  const travellerNumber = quote?.travellers?.length || 1;
  const startDate = get(quote, 'startDate', '');
  const daysDifference = differenceInDays(parse(startDate, 'dd/MM/yyyy', new Date()), new Date());
  const isFutureDate = isAfter(parse(startDate, 'dd/MM/yyyy', new Date()), new Date());
  const coverLevel = get(last(get(quote, 'premiums')), 'scheme.coverLevel', '').toLowerCase()
  const addedOptionNumber = filter(get(quote, 'options'), (o) => {
    return o === true;
  }).length
  const premium: IPremium = head(filter(quote.premiums, ['scheme.id', quote?.schemeId])) || null;
  let iconColor = 'green';
  let coverText: any = isFutureDate ? `Cover starts in ${daysDifference} days ${startDate}` : `Trip started at ${startDate}`;

  switch (status) {
    case 'expired':
      coverText = (<span>{'Quote Expired ' + get(quote, 'expiresAt', '')}</span>)
      iconColor = 'grey'
      break;
  }

  const renderCarousel = () => {

    if (quote.status === 'expired') {
      return (
        <RepurchaseQuote id={quote.id} coverLevel={coverLevel}/>
      )
    }

    return (
      <>
        <QuoteDetailsView id={quote.id}/>
      </>
    )
  }

  if (!premium) {
    return null;
  }

  return (
    <div className={'quote-card-container'}>

      <div className={'q-card-header'}>
        <div className={'q-card-icon'}>
          <IconCircle iconName={isAnnual ? 'plane-annual.svg' : 'Plane.svg'} color={iconColor}/>
        </div>
        <div style={{ width: '100%' }}>
          <div className={'q-card-h-text-container'}>
            <div className={'q-card-h-text'}>{tripDefinition}</div>
            <div className={'q-card-h-badge'}><StatusBadge status={status}/></div>
          </div>
          <div className={'q-card-destination'}>Quote Ref: {quote.quoteReference}</div>
        </div>
      </div>

      <div className={'q-card-body-container'}>
        <div className={'q-card-body'}>
          <div className={'q-properties'}>
            <div className={'prop-item'}>
              <AdmIcons name={'Calendar'} color={'blue'}/>
              <div className={'prop-item-text'}>{coverText}</div>
            </div>
            <div className={'prop-item'}>
              <AdmIcons name={'People'} color={'blue'}/>
              <div className={'prop-item-text'}>{travellerNumber + ' Traveller(s)'}</div>
            </div>
            <div className={'prop-item'}>
              <AdmIcons name={'ShieldTicked'} color={coverLevel}/>
              <div className={'prop-item-text'}>{capitalize(coverLevel) + ' cover'}</div>
            </div>
            <div className={'prop-item'}>
              <AdmIcons name={'ShieldPlus'} color={'blue'}/>
              <div
                className={'prop-item-text'}>{addedOptionNumber > 1 ? `${addedOptionNumber} Optional Extras` : 'No Optional Extras'}</div>
            </div>

            <div className={'q-buttons-container'}>
              <div style={{ flex: 1, textAlign: 'center', marginRight: '10px' }}>
                <div style={{ textAlign: 'left' }}>
                  <span style={{
                    fontSize: '20px',
                    color: quote.status === 'expired' ? '' : '#008d00',
                    fontWeight: 'bold'
                  }}>{'£' + (premium.gross).toFixed(2)}</span>
                  <span style={{ fontSize: '14px' }}>
                    {isAnnual ? ' per year' : ' total'}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className={'q-make-a-change'}>
            {renderCarousel()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        push: bindActionCreators(push, dispatch),
      }
    }),
  ),
])(QuoteCard);
